import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FaSadTear, FaHeart, FaRegHeart } from 'react-icons/fa';
import { 
    ContainerAddressRow, 
    AddressSelButton, 
    AddressName, 
    ButtonContent, 
    AddressButton, 
    ContentCreateAddress, 
    ContentLoading,
    ContentInfo
 } from './styles';
import { MdEdit, MdClose } from 'react-icons/md';
import { StoreState } from '../../store/createStore';
import { UserAddresses } from '../../store/modules/auth/types';
import { addressesEditRequest, addressesRemoveRequest, addressesSelectedRequest, addresssAll } from '../../store/modules/parameter/actions';
import { removeAddressCustomerCard, selectedAddressCustomerCard } from '../../store/modules/checkout/actions';
import AddressCreateOrUpdate from './AddressCreateOrUpdate';
import { useTranslation } from '../../hooks/useTranslation';
import Button from '../Button';
import Loading from '../Loading';

interface AddressCustomerModalProps {
    createdAddress: boolean;
    setCreatedAddress: (state: boolean) => void;
    handleadSelectShipping?: (address: UserAddresses) => void;
    customerIsSignedIn?: boolean;
    bCheckout?: boolean;
}

const AddressCustomer: React.FC<AddressCustomerModalProps> = ({
    createdAddress,
    setCreatedAddress,
    handleadSelectShipping,
    customerIsSignedIn = false,
    bCheckout = false
}: AddressCustomerModalProps) => {
    const dispatch = useDispatch();
    const { loading, addresses } = useSelector((state: StoreState) => state.parameter);
    const { checkout: { customer }, loading: loadingCheckout } = useSelector((state: StoreState) => state.checkout);
    const { onTranslation: t } = useTranslation();

    const handledAddresseEdit = useCallback((address: UserAddresses) => {
        //konsole.log('handledAddresseEdit()->address:', address)
        dispatch(addressesEditRequest(address));
        setCreatedAddress(true);
    }, [dispatch, setCreatedAddress]);

    const handledAddresseRemoved = useCallback((address: UserAddresses) => {
        if (customer?.data?.customer?.customer_id && customerIsSignedIn)
            dispatch(removeAddressCustomerCard(address, customer?.data.customer.customer_id, `${t('main.messages_toast.remove_address_sucess')}`));
        else
            dispatch(addressesRemoveRequest(address));
    }, [dispatch, customer, customerIsSignedIn, t]);

    const handledCloseChangeCustomer = useCallback(() => {
        dispatch(addressesEditRequest({} as UserAddresses));
        setCreatedAddress(false);
    }, [dispatch, setCreatedAddress]);

    const handleadSelectDefault = useCallback(async (address: UserAddresses) => {
        if (customer && address.address_id && customerIsSignedIn)
            dispatch(selectedAddressCustomerCard(Number(address.address_id), customer.data.customer.id,
                customer.data.customer.customer_id, `${t('main.messages_toast.remove_address_sucess')}`));
        else
            dispatch(addressesSelectedRequest(address, true));
    }, [dispatch, customer, customerIsSignedIn, t]);

    const handleadSelectToOrder = useCallback((e, address: UserAddresses) => {
        if (!bCheckout) return;
        if (e && (e.nativeEvent?.target?.localName === 'path' || e.nativeEvent?.target?.localName === 'svg')) return;
        if (handleadSelectShipping)
            handleadSelectShipping(address);
    }, [handleadSelectShipping, bCheckout]);

    useEffect(() => {
        dispatch(addresssAll());
    }, [dispatch]);
    
    // Se estiver criando/editando endereço, não desmontar o componente filho
    if (createdAddress) {
        return (
            <ContentCreateAddress>
                <Button
                    button={{ type: 'button', id:"button-action-close-address" }}
                    onClick={handledCloseChangeCustomer}
                    atributes={{
                        buttonType: 'outline',
                        borderColor: 'var(--primary)',
                        textColor: '#000',
                        marginLeft: "auto",
                        background: '#FFF',
                        textSize: "16px"
                    }}
                >
                    {t('main.globals.back')}
                </Button>
                <AddressCreateOrUpdate onSetModal={setCreatedAddress} />
            </ContentCreateAddress>
        )
    }
    
    // Só mostra loading quando NÃO está no modo de criação/edição
    if (loading || loadingCheckout) {
        return (<ContentLoading><Loading size={160} bShowText /></ContentLoading>);
    }

    return (
        <>
            {
                customerIsSignedIn ? (
                    <>
                        {
                            !loadingCheckout && customer && customer.data.customer.address.map((address, index) => {
                                return (
                                    <ContainerAddressRow
                                        id={`address-account-${index}`}
                                        bCheckout={bCheckout} 
                                        key={address.id} 
                                        onClick={(e) => handleadSelectToOrder(e, address)}
                                    >
                                        <AddressSelButton onClick={() => handleadSelectDefault(address)}>
                                            {address.selected ? <FaHeart color={"red"} size={25} /> : <FaRegHeart size={25} />}
                                        </AddressSelButton>
                                       <ContentInfo>
                                            <AddressName><span>{address.address_name}</span></AddressName>
                                            <div><p>{address.address},{address.number} - {address.neighborhood} - {address.city} - {address.state} - CEP: {address.postcode} </p></div>
                                       </ContentInfo>
                                        <ButtonContent>
                                            <AddressButton title={t('main.component_address_customer.change_address')} onClick={() => handledAddresseEdit(address)}>
                                                <MdEdit color="var(--btn-finish)" size={28} />
                                            </AddressButton>
                                            <AddressButton title={t('main.component_address_customer.remove_address')} onClick={() => handledAddresseRemoved(address)}>
                                                <MdClose color="var(--btn-canc)" size={28} />
                                            </AddressButton>
                                        </ButtonContent>
                                    </ContainerAddressRow>
                                )
                            })
                        }
                    </>
                ) : (
                        <>
                            {addresses && addresses.map((address, index) => {
                                return (
                                    <ContainerAddressRow 
                                        id={`address-account-${index}`}
                                        bCheckout={bCheckout} 
                                        key={address.id} 
                                        onClick={(e) => handleadSelectToOrder(e, address)}
                                    >
                                        <AddressSelButton onClick={() => handleadSelectDefault(address)}>
                                            {address.selected ? <FaHeart color={"red"} size={25} /> : <FaRegHeart size={25} />}
                                        </AddressSelButton>
                                        <ContentInfo>
                                            <AddressName><span>{address.address_name}</span></AddressName>
                                            <div><p>{address.address},{address.number} - {address.neighborhood} - {address.city} - {address.state} - CEP: {address.postcode} </p></div>
                                        </ContentInfo>
                                        <ButtonContent>
                                            <AddressButton title={t('main.component_address_customer.change_address')} onClick={() => handledAddresseEdit(address)}>
                                                <MdEdit color="var(--btn-finish)" size={28} />
                                            </AddressButton>
                                            <AddressButton title={t('main.component_address_customer.remove_address')} onClick={() => handledAddresseRemoved(address)}>
                                                <MdClose color="var(--btn-canc)" size={28} />
                                            </AddressButton>
                                        </ButtonContent>
                                    </ContainerAddressRow>
                                )
                            })
                            }
                        </>
                    )
            }

            {((addresses && addresses.length === 0 && !customerIsSignedIn) || (customerIsSignedIn && (!customer || (customer && customer.data.customer.address.length === 0)))) &&
                (!loading && !loadingCheckout) && (
                    <h4 id="address-not-exist">{t('main.component_address_customer.without_address')} <FaSadTear color="var(--primary)" size={22} /></h4>
                )}
        </>
    )
}

export default AddressCustomer;